import React from 'react';

const Nevada = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Nevada Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Disclosure statement required at least 10 days before closing.</li>
        <li>Seller’s Real Property Disclosure: Mandatory.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Nevada-Sellers-Real-Property-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Seller's Real Property Disclosure Form{' '}
          </span>{' '}
          – Nevada requires property sellers to provide buyers with an
          accounting of the property's condition at least 10 days before
          transferring ownership.
        </li>
      </ol>
    </div>
  );
};

export default Nevada;
